export const PERMISSIONS = {
  Package__AllowView: 1,
  Package__AllowEdit: 2,
  Package__AllowChangeStatus: 5,
  Account__AllowView: 6,
  Account__AllowEdit: 7,
  Pricing__ApprovalNeeded: 15,
  Settings__NotificationAdministrator: 16,
  Package__AllowFinalPricing: 22,
  Package__AllowRequestInspection: 23,
  Package__AllowAssignInspector: 27,
  Package_AllowExecuteRiskPackage: 28,
  Pricing__AllowViewDashboard: 29,
  Package__AllowViewContracts: 30,
  Package__AllowViewInspections: 31,
  Inventory__AllowView: 32,
  Inventory__AllowEdit: 33,
  Inventory__AllowChangeStatus: 35,
  Inventory__AllowValidateDescription: 36,
  Inventory__AllowValidateInspection: 37,
  Inventory__AllowValidateLocation: 38,
  Inventory__AllowValidateTitle: 39,
  Inventory__AllowValidateLien: 40,
  Inventory__AllowValidateBlueChip: 41,
  Settings__InspectionTemplateAdministrator: 45,
  Settings__SalesGoals: 48,
  Inventory__AllowValidateQualityControl: 49,
  Account__AllowChangeOwner: 50,
  WorkOrder__AllowEditInspectionRequest: 51,
  WorkOrder__AllowEditInspection: 52,
  Inventory__AllowAddRetailSale: 53,
  Package__Administrator: 54,
  Settings__MakeModelAdministrator: 55,
  Inventory__VerificationAdministrator: 56,
  Package__ViewAudit: 57,
  WorkOrder__ViewDashboard: 58,
  Inventory__AllowUnSell: 59,
  Package_AllowEditCommissions: 60,
  Inventory_AllowAuctionPricing: 61,
  Package__SetRiskPreAuctionPricing: 65,
  Package__SetConsignementRetailPricing: 66,
  Inventory__OverrideAuctionPricing: 67,
  Inventory__AllowDisplayOnline: 68,
  Settings__RoundRobinAdmin: 69,
  Inventory__AllowValidatePricing: 70,
  EquifyAuctions__ManageAuctions: 71,
  Account_AllowSalesAgreeementDocusignBypass: 72,
  EquifyAuctions__ViewItemAnalytics: 73,
  Package__EditInspection: 74,
  Package__DetailOverride: 75,
  EquifyAuctions__UserAdministrator: 76,
  Settings__FeeAdministrator: 77,
  Settings__FamilyAdministrator: 78,
  Settings__ChartOfAccountsAdministrator: 79,
  Package__ViewBuyerStatement: 80,
  Package__EditBuyerStatement: 81,
  Settings__BuyerPremiumTier: 82,
  Settings__TransactionFeeTier: 83,
  Settings__OperationsConfiguration: 84,
  Package__ManageBuyerInvoice: 85,
  WorkOrder__AllowEditOffer: 86,
  Account_InvoiceAdministrator: 87,
  Package__ViewSalesActivity: 88,
  Reports__Verifications: 89,
  Reports__InventoryLocations: 90,
  Accounts__ApplyPayments: 91,
  Accounts__VoidPayments: 92,
  Package_AllowAddActivity: 93,
  EquifyAuctions__AllowManageWebsiteDocuments: 94,
  Account__GeneralJournalAdministrator: 95,
  Lead__AllowView: 96,
  Lead__AllowCreate: 97,
  Lead__AllowEdit: 98,
  Lead__AllowChangeLeadOwner: 99,
  Inventory__AllowEditSaleFormat: 100,
  EquifyAuctions_ManageIncentives: 101,
  EquifyAuctions__CanSendBuyingBiddingRightsInvite: 102,
  EquifyAuctions__CanSendGeneralInvite: 103,
  Inventory__AllowValidateSellerPickup: 104,
  WorkOrder_AllowDelete: 106,
  Account_Post_GL_NAV: 107,
  Account_Unpost_GL_NAV: 108,
  Settings__BidIncrementTierAdministrator: 109,
  Account__AllowRequestPayment: 113,
  Account__PaymentRequestAdministrator: 114,
  Settings__UserAdministrator: 115,
  Package__ViewDownlineOnly: 116,
  Package__ViewRegionOnly: 117,
  WorkOrder__ViewOffer: 118,
  WorkOrder__ViewInspection: 119,
  WorkOrder__ViewInspectionRequest: 120,
  WorkOrder__ViewFreight: 121,
  WorkOrder__ViewPaymentRequest: 122,
  Inventory__ViewDownlineOnly: 123,
  Inventory__ViewRegionOnly: 124,
  WorkOrder__ViewDownlineOnly: 125,
  WorkOrder__ViewRegionOnly: 126,
  Settings__RegionAdministrator: 127,
  Settings__ContactTypeAdministrator: 128,
  Settings__CompetitorAdministrator: 129,
  Settings__MotivationAdministrator: 130,
  Settings__BlueChipAdministrator: 131,
  Account__MergeAccounts: 132,
  Package__PerformInspections: 133,
  Pricing__PerformPricing: 134,
  Dashboard__Sales: 135,
  Dashboard__Inventory: 136,
  Dashboard__Pricing: 137,
  Dashboard__Verification: 138,
  Dashboard_AuctionManager: 139,
  Account__OverrideSalesAgreement: 140,
  WorkOrder_AllowEditPaymentRequest: 141,
  Account_EditBankInfo: 142,
  Account_ViewBankInfo: 143,
  Account_CreateBankAccount: 144,
  Inventory__AllowValidateEvent: 145,
  Inventory__OverrideEvent: 146,
  Inventory__OverrideIdentity: 147,
  Inventory__OverrideStockNumber: 148,
  Inventory__OverrideHorsePower: 149,
  Inventory__OverrideAssetNumber: 150,
  Inventory__OverrideMeters: 151,
  Inventory__OverrideDetails: 152,
  Inventory__OverrideAdditionalDetails: 153,
  Settings__DataImport: 154,
  Auction_Auctioneer: 155,
  Auction_AuctionClerk: 156,
  Auction_CanRemoveReserve: 157,
  Auction_CreateLotNumbers: 159,
  Auction_CreateCatalog: 160,
  Auction_Cataloged: 161,
  Auction_RollbackCatalog: 162,
  Auction_Presenter: 163,
  Settings__NoDealReasons: 164,
  Account__CollectionsView: 165,
  Settings__ChatPhraseAdministrator: 166,
  Accounts__RefundDeposit: 167,
  Inventory__OverrideLocation: 168,
  Reports__PaymentReconcilation: 169,
  Settings__TaxExemptionAdministrator: 170,
  Reports__RevenueSummary: 171,
  Reports__InvoiceRegister: 172,
  Reports__Receivables: 173,
  Reports__LienStatus: 174,
  Package__RequestMarketValue: 175,
  Package__OverridePriceYourOwnPackage: 176,
  Package__AllowDeactivateValuation: 177,
  Auction__LockRunOrder: 178,
  Auction__UnLockRunOrder: 179,
  Auction__LockPaymentTerms: 180,
  Auction__UnLockPaymentTerms: 181,
  Auction__LockTermsAndConditions: 182,
  Auction__UnLockTermsAndConditions: 183,
  Auction__SellItem: 184,
  Reports__InventoryDetail: 185,
  Inventory__OverrideDisclaimer: 186,
  Accounts__RefundInvoiceCredit: 187,
  Accounts__ManageReceivables: 188,
  Accounts__EditVIP: 189,
  Account__AllowRequestAdvancedPayment: 190,
  Package__OverideBuyerPremiumTier: 191,
  Settings__BuyBackTier: 192,
  Auction__ActionExtendTime: 193,
  Auction__ActionApplyDeduct: 194,
  Auction__ActionSchedulePaymentWorkOrderBypass: 195,
  Settings__ConnectQuickBooks: 196,
  Inventory__PrintUnpaidReleaseTicket: 197,
  Package__EditBuybackFee: 200,
  Simulcast__Tote: 210,
  Simulcast__VirtualRingman: 211,
  Show__SettingsMenu: 99001,
  Show__PackagesMenu: 99002,
  Show__OperationsMenu: 99003,
  Show__AccountingMenu: 99004,
  System__NotQuickbooks: 99996,
  System__Quickbooks: 99997,
  System__SuperUser: 99998,
  System__DebugMode: 99999,
};

export const BIDDING_STATUS = {
  Paused: 0,
  InProgress: 1,
};

export const EVENT_STATUS = {
  Active: 1,
  Upcoming: 2,
  InProgress: 3,
  Completed: 4,
  Closed: 5,
  Catalogued: 6,
  LotNumbersAssigned: 7,
  DidNotRun: 8,
};

export const BID_TYPES = {
  Online: 1,
  FloorBid: 2,
  MaxBid: 3,
  ThirdParty: 4,
};

export const ITEM_STATUS = {
  Allocated: 3,
  Sold: 4,
  NoSale: 5,
  Retail: 7,
  Upcoming: 8,
  OnTheBlock: 10,
  PendingSale: 15,
  ReserveNotMet: 17,
  DidNotSellBuyback: 18,
  DidNotSellHouse: 19,
  PendingProviderImport: 20,
};

export const ITEM_STATUS_LABEL = {
  [ITEM_STATUS.Allocated]:             "Allocated",
  [ITEM_STATUS.Sold]:                  "Sold",
  [ITEM_STATUS.NoSale]:                "No Sale",
  [ITEM_STATUS.Retail]:                "Retail",
  [ITEM_STATUS.Upcoming]:              "Upcoming",
  [ITEM_STATUS.OnTheBlock]:            "On The Block",
  [ITEM_STATUS.PendingSale]:           "Pending Sale",
  [ITEM_STATUS.ReserveNotMet]:         "Reserve Not Met",
  [ITEM_STATUS.DidNotSellBuyback]:     "Did Not Sell - Buyback",
  [ITEM_STATUS.DidNotSellHouse]:       "Did Not Sell - House",
  [ITEM_STATUS.PendingProviderImport]: "Pending Provider Import",
};

export const RECIPIENT_TYPE = {
  All: 1,
  SelectedUsers: 2,
  Clerk: 3,
  ActiveBidders: 4,
};

export const BLOCK_TYPES = {
  Single: 0,
  Group: 1,
};

export const SOLD_STATUSES = [
  ITEM_STATUS.Sold,
  ITEM_STATUS.NoSale,
  ITEM_STATUS.PendingSale,
  ITEM_STATUS.PendingProviderImport,
  ITEM_STATUS.ReserveNotMet,
  ITEM_STATUS.DidNotSellBuyback,
  ITEM_STATUS.DidNotSellHouse,
];

export const BID_STATUS = {
  Winning: "winning",
  Outbid: "outbid",
};

export const EVENT_TYPE = {
  Online: 1,
  Simulcast: 2,
  ThirdParty: 3,
};